import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function PhoneActionModal({ isOpen, onClose, phone }) {
  if (!isOpen) return null;
  const normalized = String(phone || '').trim();
  if (!normalized) return null;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-lg bg-white shadow-xl transition-all">
                <div className="flex items-start justify-between border-b px-6 py-4">
                  <Dialog.Title className="text-lg font-semibold text-NBNA-primary">Phone</Dialog.Title>
                  <button type="button" className="text-sm text-gray-600" onClick={onClose}>Close</button>
                </div>

                <div className="px-6 py-5 space-y-3">
                  <div className="text-sm text-gray-700">{normalized}</div>

                  <a
                    className="btn-primary w-full block text-center"
                    href={`tel:${normalized}`}
                    onClick={() => onClose?.()}
                  >
                    Call
                  </a>

                  <a
                    className="btn-secondary w-full block text-center"
                    href={`sms:${normalized}`}
                    onClick={() => onClose?.()}
                  >
                    SMS
                  </a>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
